import { render, staticRenderFns } from "./EditKlant.vue?vue&type=template&id=16875f2c&scoped=true&"
import script from "./EditKlant.vue?vue&type=script&lang=js&"
export * from "./EditKlant.vue?vue&type=script&lang=js&"
import style0 from "./EditKlant.vue?vue&type=style&index=0&id=16875f2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16875f2c",
  null
  
)

export default component.exports